module.exports = __webpack_public_path__ + "img/balogh_tunde.a91107f1.jpg";